import { render, staticRenderFns } from "./person_sync_table.vue?vue&type=template&id=352103f9&"
import script from "./person_sync_table.vue?vue&type=script&lang=js&"
export * from "./person_sync_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352103f9')) {
      api.createRecord('352103f9', component.options)
    } else {
      api.reload('352103f9', component.options)
    }
    module.hot.accept("./person_sync_table.vue?vue&type=template&id=352103f9&", function () {
      api.rerender('352103f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/registrations/person_sync_table.vue"
export default component.exports